import List from '@mui/material/List';
import { styled } from '@mui/material/styles';

export const StyledList = styled(List, {
  shouldForwardProp: prop => prop !== 'listHeight',
})<{ listHeight: number }>`
  height: ${({ listHeight }) => listHeight}px;
`;
